import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { FormSubmitHandler, submit } from "redux-form";

import { Wrapper } from "../../../components";
import { MetaTags } from "../../../head";
import { RootState, Dispatch } from "../../../store/types";
import { Step5State } from "../reducer";
import * as actions from "../actions";
import * as selectors from "../selectors";
import * as constants from "../constants";
import { SuppInfoFormValues } from "./SuppInfoForm";
import { selectors as step1Selectors, State as Step1State } from "../../Step1";
import { selectors as summarySelectors } from "../../WizardSummary";
import WizardFormLayout from "../../Wizard/components/WizardFormLayout";
import SuppInfoForm from "./SuppInfoForm";

export interface Step5ContainerProps extends Step5State, Step1State {
  isPaymentUpfrontForced: boolean;
  savedFormValues: SuppInfoFormValues;
  currFormValues: SuppInfoFormValues;
  isTOCChecked: boolean;
  saveFormValues: (v: Partial<SuppInfoFormValues>) => void;
  sendOrderRequest: () => void;
  triggerFormSubmit: () => void;
}

class Step5Container extends React.Component<Step5ContainerProps> {
  public componentWillUnmount() {
    this.props.saveFormValues(this.props.currFormValues);
  }

  public render() {
    // Go to step 1 if no product chosen
    if (!this.props.chosenProduct) {
      return <Redirect to="/wizard/step-1" />;
    }

    return (
      <Wrapper>
        <MetaTags title="Thông tin khách hàng" />
        <WizardFormLayout
          leftColPreMatter="Giá và thời gian sẽ thay đổi theo những tuỳ chọn của bạn"
          rightColPreMatter="Chi tiết đơn hàng"
          actionBtn={this.renderSubmitButton()}
          hasTOC
        >
          <SuppInfoForm
            initialValues={this.getInitFormValues()}
            onSubmit={this.handleFormSubmit}
            paymentUpfrontOptions={this.renderPaymentUpfrontOptions()}
            additionalDesignOptions={this.renderAdditionalDesignOptions()}
            {...this.props}
          />
        </WizardFormLayout>
      </Wrapper>
    );
  }

  private renderSubmitButton = () => (
    <button
      className="action-btn"
      type="button"
      disabled={!this.props.isTOCChecked}
      onClick={this.props.triggerFormSubmit}
    >
      Đặt Hàng
      {this.props.isSubmitting && (
        <i className="fa fa-fw fa-pulse fa-spinner" />
      )}
    </button>
  );

  private renderPaymentUpfrontOptions = () =>
    constants.PAYMENT_UPFRONT_OPTIONS.map((props, i) => (
      <option key={i} {...props} />
    ));

  private renderAdditionalDesignOptions = () =>
    constants.ADD_DESIGNS_OPTIONS.map((props, i) => (
      <option key={i} {...props} />
    ));

  private getInitFormValues = (): Partial<SuppInfoFormValues> => ({
    payment_upfront_rate: constants.PAYMENT_UPFRONT_OPTIONS[0].value,
    has_payment_upfront: this.props.isPaymentUpfrontForced.toString(),
    ...this.props.savedFormValues,
  });

  private handleFormSubmit: FormSubmitHandler<SuppInfoFormValues> = values => {
    this.props.saveFormValues(values);
    this.props.sendOrderRequest();

    (window as any).gtag("event", "conversion", {
      send_to: "AW-937006589/GcdXCK6o3qcBEP2r5r4D",
    });
  };
}

const mapStateToProps = (state: RootState): Partial<Step5ContainerProps> => ({
  chosenProduct: step1Selectors.chosenProduct(state),
  isPaymentUpfrontForced: selectors.isPaymentUpfrontForced(state),
  currFormValues: selectors.currFormValues(state),
  savedFormValues: selectors.savedFormValues(state),
  isTOCChecked: summarySelectors.isTOCChecked(state),
});

const mapDispatchToProps = (
  dispatch: Dispatch,
): Partial<Step5ContainerProps> => ({
  sendOrderRequest: () => dispatch(actions.sendOrderRequest()),
  saveFormValues: (v: Partial<SuppInfoFormValues>) =>
    dispatch(actions.setSuppFormValues(v)), // persist form values
  triggerFormSubmit: () => dispatch(submit(constants.SUPP_INFO_FORM)), // trigger redux-form submit
});

export default connect(mapStateToProps, mapDispatchToProps)(Step5Container);



// WEBPACK FOOTER //
// ./src/routes/Step5/components/Step5Container.tsx